import { rankWith, uiTypeIs, LayoutProps } from '@jsonforms/core';
import {
  ResolvedJsonFormsDispatch,
  withJsonFormsLayoutProps,
} from '@jsonforms/react';
import { cloneDeep } from 'lodash';
import { useEffect, useState } from 'react';
import { useQParam } from '../../../../../hooks/useQParam';
import { TruAction, TruInvokeAction, TruInvokeActionData } from '../../../../../types';
import { getElements, getLabel } from '../../../../../utils/DynamicForms'; 

import './style.scss';

type Props = LayoutProps;

// const getMappedChanges = (quotes: MarketQuote[], quoteId: string) => {
//   return quotes.map((quote: MarketQuote, index: number) => ({
//     path: `quotes[${index}].status`,
//     value: quote.id === quoteId ? 'binding' : quote.status,
//   }));
// };

const PurchaseLayout = (props: Props) => {
  const quoteId = useQParam('quote-id');
  const [quoteIdState, setQuoteIdState] = useState(quoteId)

  useEffect(() => {
    setQuoteIdState(quoteId)
  }, [quoteId])

  if (!quoteId) return null;

  return (
    <div className="tru-layout-purchase">
      <div className="purchase-header">
        <span>{getLabel(props.uischema)}</span>
      </div>
      <div className="purchase-controls">
        {getElements(props.uischema).map((element: any, index) => {
          if (element.type === 'ButtonControl' && element?.options?.executeQuoteKey) {
            element.actions = element.actions.map((action: TruAction) => {
              if (
                action.key === 'invoke' &&
                (action as TruInvokeAction).data?.quoteKey
              ) {
                const updatedAction: TruInvokeAction = cloneDeep(action);
                (updatedAction.data as TruInvokeActionData).quoteKey = (
                  updatedAction.data as TruInvokeActionData
                ).quoteKey?.replaceAll?.('$quote-id', quoteIdState);
                return updatedAction;
              }

              return action;
            });
          }
          return (
            <ResolvedJsonFormsDispatch
              {...props}
              uischema={element}
              key={index}
            />
          );
        })}

      </div>
    </div>
  );
};

export const PurchaseLayoutEntry = {
  tester: rankWith(1, uiTypeIs('PurchaseLayout')),
  renderer: withJsonFormsLayoutProps(PurchaseLayout),
};
